/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    dispName
    mail
    role
    spApiFlg
    secret
    settings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $id: ID
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUsers(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      dispName
      mail
      role
      spApiFlg
      secret
      settings
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const CallFuncGetProduct = /* GraphQL */ `query CallFuncGetProduct($code: String!) {
  CallFuncGetProduct(code: $code)
}
` as GeneratedQuery<
  APITypes.CallFuncGetProductQueryVariables,
  APITypes.CallFuncGetProductQuery
>;
export const CallFuncOperateFee = /* GraphQL */ `query CallFuncOperateFee($type: String!, $asin: String, $price: Int) {
  CallFuncOperateFee(type: $type, asin: $asin, price: $price)
}
` as GeneratedQuery<
  APITypes.CallFuncOperateFeeQueryVariables,
  APITypes.CallFuncOperateFeeQuery
>;
